import React, { Component } from "react";
import { Button, Form, Icon, Grid } from "tabler-react";
import { Crud_Catalogos } from '../../herramientas/Crud_Catalogos';
import Select from "react-select";

class ServiceFailureForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      id: "",
      nombre: "",
      descripcion: "",
      estatus: false,
      categoria: { value: 0, label: "Selecciona una categoría" },
      accion: this.props.accion, //'nuevo'// modificar, nuevo
      crudbutonEnable: true, // Se desabilita cuando se hace click
      categorias: [], // Array para las opciones del Select
    };
    this.serviceFailureObject = [];
    this.enableSave = this.enableSave.bind(this);
  }
  isEnable = (Accion) => {
    let borrar = "incidencias_borrar";
    let actualizar = "incidencias_editar";
    let agregar = "incidencias_agregar";
    var privilegios = this.props.stor.privilegios_object;
    var perfil = JSON.parse(sessionStorage.getItem("perfil"));
    for (let i = 0; i < privilegios.length; i++) {
      if (Accion === "borrar") {
        if (privilegios[i].clave == borrar) {
          if (
            perfil.privilegios.filter(
              (word) => word.idPrivilegio == privilegios[i].id
            ).length > 0
          ) {
            return true;
          }
        }
      }
      if (Accion === "actualizar") {
        if (privilegios[i].clave == actualizar) {
          if (
            perfil.privilegios.filter(
              (word) => word.idPrivilegio == privilegios[i].id
            ).length > 0
          ) {
            return true;
          }
        }
      }
      if (Accion === "agregar") {
        if (privilegios[i].clave == agregar) {
          if (
            perfil.privilegios.filter(
              (word) => word.idPrivilegio == privilegios[i].id
            ).length > 0
          ) {
            return true;
          }
        }
      }
    }
    return false;
  };
  componentDidMount = () => {
    //console.log(this.props);
    this.loadCategorias();
    if (this.state.accion === "nuevo") {
      this.serviceFailureObject = this.props.elementos;
    } else {
      this.setState({ id: this.props.elementos.id });
      this.setState({ nombre: this.props.elementos.nombre });
      this.setState({ descripcion: this.props.elementos.descripcion || "" });
      this.setState({ estatus: this.props.elementos.estatus });
      
      // Configurar categoría seleccionada si existe
      if (this.props.elementos.categoria) {
        this.setState({ 
          categoria: { 
            value: this.props.elementos.categoria.id, 
            label: this.props.elementos.categoria.nombre,
            data: this.props.elementos.categoria
          }
        });
      }
    }
  };

  loadCategorias = () => {
    Crud_Catalogos("service-failure-categorias/list-active", "serviceFailures", "get").then((returnVal) => {
      if (Array.isArray(returnVal)) {
        // Convertir al formato requerido por react-select con data
        let categoriasTemp = returnVal.map(cat => ({
          value: cat.id,
          label: cat.nombre,
          data: cat
        }));
        this.setState({ categorias: categoriasTemp });
      }
    }).catch(err => {
      console.log('Error cargando categorías:', err);
      this.setState({ categorias: [] });
    });
  };

  enableSave = () => {
    //console.log("Enable button: "+this.state.nombre)
    if (this.state.nombre.length > 0) {
      return false;
    } else {
      return true;
    }
  };

  changeName = (event) => {
    this.setState({ nombre: event.target.value });
    //console.log("nombre: " + this.state.nombre);
  };

  changeDescripcion = (event) => {
    this.setState({ descripcion: event.target.value });
  };

  changeCategoria = (selectedOption) => {
    this.setState({ categoria: selectedOption });
  };

  changeEstatus = (event) => {
    //console.log("Checked: " + event.target.checked);
    this.setState({ estatus: event.target.checked ? true : false });
  };
  guardarSF = () => {
    if (this.state.accion === "modificar") this.crud_put();
    else this.crud_post();
    this.props.cerrarModal();
  };
  delete() {
    this.setState({ crudbutonEnable: false });
    this.props.getfuntion("delete", "", this.state.id);
  }
  crud_put() {
    this.setState({ crudbutonEnable: false });
    this.props.getfuntion("put", {
      id: this.state.id,
      nombre: this.state.nombre,
      descripcion: this.state.descripcion,
      estatus: this.state.estatus,
      categoria: this.state.categoria.data || null,
    });
  }
  crud_post() {
    this.setState({ crudbutonEnable: false });
    this.props.getfuntion("post", {
      nombre: this.state.nombre,
      descripcion: this.state.descripcion,
      estatus: this.state.estatus,
      categoria: this.state.categoria.data || null,
    });
  }
  render() {
    return (
      <div>
        {this.state.accion === "modificar" ? (
          <h1>{this.props.elementos.nombre}</h1>
        ) : null}
        <Grid.Row>
          <Grid.Col md={12} xl={12}>
            <Grid.Row>
              <Grid.Col md={3} lg={3}>
                <Form.Group label="ID">
                  <Form.Input
                    name="id"
                    disabled
                    type="number"
                    value={this.state.id}
                  />
                </Form.Group>
              </Grid.Col>
              <Grid.Col md={9} lg={9}>
                <Form.Group label="Nombre">
                  <Form.Input
                    name="nombre"
                    type="text"
                    value={this.state.nombre}
                    onChange={this.changeName}
                    maxLength="60"
                  />
                </Form.Group>
              </Grid.Col>
            </Grid.Row>
            
            <Grid.Row>
              <Grid.Col md={12}>
                <Form.Group label="Descripción">
                  <Form.Textarea
                    name="descripcion"
                    value={this.state.descripcion}
                    onChange={this.changeDescripcion}
                    placeholder="Descripción del Service Failure"
                    maxLength="300"
                    rows={4}
                  />
                </Form.Group>
              </Grid.Col>
            </Grid.Row>

            <Grid.Row>
              <Grid.Col md={6}>
                <Form.Group label="Categoría">
                  <Select
                    value={this.state.categoria}
                    onChange={this.changeCategoria}
                    options={this.state.categorias}
                    placeholder="Selecciona una categoría"
                  />
                </Form.Group>
              </Grid.Col>
              <Grid.Col md={6}>
                <Form.Group label="Estatus">
                  <Form.Switch
                    name="estatus"
                    label="Activo"
                    value={this.state.estatus}
                    checked={this.state.estatus}
                    onChange={this.changeEstatus}
                  />
                </Form.Group>
              </Grid.Col>
            </Grid.Row>
          </Grid.Col>
        </Grid.Row>

        <div className="float-right">
          {this.isEnable("actualizar") || this.isEnable("agregar") ? (
            <span className="badge">
              <Button
                target="_blank"
                size="sm"
                RootComponent="a"
                color="primary"
                disabled={this.enableSave() || !this.state.crudbutonEnable}
                onClick={this.guardarSF}
              >
                <span className="badge">
                  <Icon link={true} name="save" />
                  Guardar
                </span>
              </Button>
            </span>
          ) : null}
          {this.state.accion === "modificar" && this.isEnable("borrar") ? (
            <span className="badge">
              <Button
                target="_blank"
                size="sm"
                RootComponent="a"
                color="primary"
                onClick={() => this.delete()}
                disabled={!this.state.crudbutonEnable}
              >
                <span className="badge">
                  <Icon link={true} name="trash" />
                  Borrar
                </span>
              </Button>
            </span>
          ) : null}
        </div>
      </div>
    );
  }
}
export default ServiceFailureForm;
